import {useCallback, useEffect, useState} from 'react';
import Mediator, {useMediator} from '@core-ui/mediator';
import {SortByChange, SortByValue, Direction} from '@cat/sort-by';

interface UseSortBy {
  onChange: SortByChange;
  value: SortByValue | null;
}

const allEmpty = fields => fields.every(array => array.length === 0)

const useSortBy = (): UseSortBy => {
  const {publish, state} = useMediator(Mediator.mediators['left-faceted-grid']);
  const [value, setValue] = useState<SortByValue | null>(null);
  const applied = state?.facets?.appliedFacets;

  useEffect(() => {
    const {sortByField = [], sortByDir = []} = applied ?? {};

    if (allEmpty([sortByField, sortByDir])) {
      return setValue(null);
    }

    const [field] = sortByField;
    const [direction] = sortByDir;

    setValue({
      direction: direction.id,
      field: field.id,
      label: field.name,
    });
  }, [applied]);

  const onChange = useCallback((event: SortByValue) => {
    const {direction: dir, field, label} = event;
    const applied = Object.values(Direction).includes(dir) && dir !== Direction.Unset;

    const direction = {
      applied,
      facetName: 'sortByDir',
      facetType: 'sortByDir',
      id: dir,
      name: label,
    };

    const sortBy = {
      applied,
      direction,
      facetName: 'sortByField',
      facetType: 'sortByField',
      id: field,
      name: label,
    };

    setValue(event);

    publish('updateFacets', [sortBy]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {value, onChange};
};

export default useSortBy;
